import { z } from 'zod';

export interface InternalPhoneNumberDto {
  id: string;
  name: string;
  number: string;
  timeZone: string;
  shouldRecord: boolean;
  recordGuideOnly: boolean;
}

export interface InternalPhoneNumberAdminViewDto {
  id: string;
  number: string;
  description: string;
  displayName: string;
  timezone: string;
  isDefault: boolean;
  smsUrl: string;
  voiceUrl: string;
  statusCallback: string;
  sid: string;
  isFeedbackNumber?: boolean;
  friendlyName?: string;
  supportUserIds?: string[];
  shouldRecord: boolean;
  recordGuideOnly: boolean;
}

export const CreateInternalPhoneNumberSchema = z
  .object({
    number: z
      .string()
      .regex(/^\+1\d{10}$/, 'Phone number is required and must be 10 digits'),
    description: z.string().nonempty('required'),
    displayName: z.string().optional(),
    timezone: z.string(),
    isDefault: z.boolean().default(false),
    isFeedbackNumber: z.boolean().default(false),
    sid: z.string().nonempty('required'),
    friendlyName: z.string().optional(),
    supportUserIds: z.array(z.string()).optional(),
  })
  .strict();

export type CreateInternalPhoneNumberRequest = z.infer<
  typeof CreateInternalPhoneNumberSchema
>;

export const UpdateInternalPhoneNumberSchema = z
  .object({
    number: z
      .string()
      .regex(/^\+1\d{10}$/, 'Phone number is required and must be 10 digits')
      .optional(),
    description: z.string().optional(),
    displayName: z.string().optional(),
    timezone: z.string().optional(),
    isDefault: z.boolean().optional(),
    isFeedbackNumber: z.boolean().optional(),
    sid: z.string().optional(),
    friendlyName: z.string().optional(),
    supportUserIds: z.array(z.string()).optional(),
  })
  .strict();

export type UpdateInternalPhoneNumberRequest = z.infer<
  typeof UpdateInternalPhoneNumberSchema
>;
